import React from 'react';
import { PageHeader } from 'antd';

import { RequestsList } from '@containers/requests';

import './Requests.less';

function RequestsPage() {
  return (
    <div className="properties main-page">
      <PageHeader
        title="Requests"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
      />

      <RequestsList />
    </div>
  );
}

export default RequestsPage;
